import { motion } from "framer-motion";

export default function GroupTitlePage({
  title,
  desc,
}: {
  title: string;
  desc: string;
}) {
  return (
    <motion.div
      className="text-center max-lg:px-6 max-md:px-4"
      // initial={{ opacity: 0, y: 20 }}
      // whileInView={{ opacity: 1, y: 0 }}
      // viewport={{ once: true }}
      // transition={{ duration: 0.4 }}
    >
      <motion.h1
        className="relative mb-4 inline-block text-3xl font-bold text-white md:text-4xl"
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        {title}
        <motion.div
          className="absolute -bottom-4 left-1/2 h-1 -translate-x-1/2 bg-white"
          initial={{ width: 0, opacity: 0 }}
          animate={{ width: "30%", opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.4 }}
        />
      </motion.h1>
      <motion.div
        className="mx-auto mt-6 max-w-3xl text-lg text-white"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        {desc}
      </motion.div>
    </motion.div>
  );
}
